import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

// Importar los estilos de Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CardProductos from "./CardProductos";

export default function Productos({ productos }) {
  return (
    <section className="w-full bg-sidom-light dark:bg-sidom-blue overflow-hidden ">
      <div className=" ">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="productos-swiper"
        >
          {productos.map((producto, index) => (
            <SwiperSlide key={index}>
              <CardProductos
                icon={producto.icon}
                img={producto.img}
                title={producto.title}
                description={producto.description}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
